import Request from "@/services/api/Request";

import { API_URL } from "@/constants";

export const routes = {
  info: `${API_URL}/users/show`,
  complain: `${API_URL}/complain`
};

export const request = new Request("user");

export default {
  info() {
    return request.get(routes.info);
  },
  complain(params) {
    return request.post(routes.complain, params);
  }
};
